declare global {
  interface Window {
    isGtmLoadStarted?: boolean;
    googleTagManagerId: string;
  }
}

export function loadGoogleTagManagerScript(): void {
  if (typeof window === 'undefined') return;
  if (!window.googleTagManagerId) return;
  if (window?.isGtmLoadStarted) return;
  window.isGtmLoadStarted = true;

  const id = window.googleTagManagerId;

  const elScript = document.createElement('script');
  const script = `(function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
    new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
    j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
    'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
    })(window,document,'script','dataLayer','${id}');`;
  elScript.innerHTML = script;
  document.head.insertBefore(elScript, document.head.childNodes[0]);
}
